import ExcelJS from 'exceljs'

// Function to encode data (like encryption but simpler)
const encodeData = (data) => btoa(encodeURIComponent(data));

// Function to decode data
const decodeData = (data) => decodeURIComponent(atob(data));

// Function to save user data to local storage (only on the client side)
export const saveUserDataToLocal = (userData) => {
    if (typeof window === "undefined") return;
    // if (typeof window !== "undefined") {
    const encodedKey = encodeData("adminData"); // Encode Key
    const encodedValue = encodeData(JSON.stringify(userData)); // Encode Value
    localStorage.setItem(encodedKey, encodedValue);
    // }
}

// Function to get user data from local storage
export const getUserDataFromLocal = () => {
    if (typeof window === "undefined") return;
    // if (typeof window !== "undefined") {
    const encodedKey = encodeData("adminData"); // Encode Key
    const encodedValue = localStorage.getItem(encodedKey);
    return encodedValue ? JSON.parse(decodeData(encodedValue)) : null;
    // }
    return null;
}

// Function to remove user data from local storage
export const removeUserDataFromLocal = () => {
    if (typeof window === "undefined") return;
    // if (typeof window !== "undefined") {
    const encodedKey = encodeData("adminData"); // Encode Key
    localStorage.removeItem(encodedKey);
    // }
}

export const setLocalStorageItem = (key, value) => {
    if (typeof window === "undefined") return;
    // if (typeof window !== "undefined") {
    const encodedKey = encodeData(key); // Encode Key
    const encodedValue = encodeData(JSON.stringify(value)); // Encode Value
    localStorage.setItem(encodedKey, encodedValue);
    // }
};

export const getLocalStorageItem = (key, defaultValue) => {
    if (typeof window === "undefined") return;
    // if (typeof window !== "undefined") {
    const encodedKey = encodeData(key); // Encode Key
    const encodedValue = localStorage.getItem(encodedKey);

    if (encodedValue) {
        try {
            return JSON.parse(decodeData(encodedValue));
        } catch (e) {
            console.error("Error decoding localStorage value", e);
            return defaultValue;
        }
    }
    // }
    return defaultValue;
};

export const getToken = () => {
    if (typeof window === "undefined") return null;

    const adminData = getUserDataFromLocal();
    return adminData?.admin_device_info?.token || null;
};


export const hasPermissionForModule = (moduleName) => {
    const adminData = getUserDataFromLocal();
    if (!adminData) return false;

    // ✅ Super admin (admin_id === "0")
    if (Number(adminData.admin_id) === 0) return true;

    const permission = adminData.permission?.find(
        (perm) =>
            perm.permission_module?.name?.toLowerCase() ===
            moduleName.toLowerCase()
    );

    return Boolean(permission?.is_view);
};


export const getUserPermissions = (moduleName) => {

    const adminData = getUserDataFromLocal()
    const permission =
        adminData?.permission && adminData?.permission?.find((perm) => perm.permission_module.name.toLowerCase() === moduleName.toLowerCase())

    return permission || {}
}

export const isAdmin = () => {
    const adminData = getUserDataFromLocal();

    return Number(adminData?.admin_id) === 0;
};

export const getDateRange = (period) => {
    const today = new Date();
    let startDate, endDate;

    switch (period) {
        case "today":
            startDate = endDate = today.toISOString().slice(0, 10);
            break;
        case "week":
            // Get the most recent Sunday
            const currentSunday = new Date(today);
            currentSunday.setDate(today.getDate() - today.getDay());
            // Get the upcoming Saturday
            const currentSaturday = new Date(currentSunday);
            currentSaturday.setDate(currentSunday.getDate() + 6);
            startDate = currentSunday.toISOString().slice(0, 10);
            endDate = currentSaturday.toISOString().slice(0, 10);
            break;
        case "month":
            startDate = new Date(today.getFullYear(), today.getMonth(), 1).toISOString().slice(0, 10);
            endDate = today.toISOString().slice(0, 10);
            break;
        case "year":
            startDate = new Date(today.getFullYear(), 0, 1).toISOString().slice(0, 10);
            endDate = today.toISOString().slice(0, 10);
            break;
        default:
            startDate = endDate = today.toISOString().slice(0, 10);
    }

    return { startDate, endDate };
};

// ---------------------------
// previous date range helper
// ---------------------------
export const getPreviousDateRange = (period) => {
    const today = new Date();
    let startDate, endDate;

    switch (period) {
        case "today":
            const yesterday = new Date(today);
            yesterday.setDate(today.getDate() - 1);
            startDate = endDate = yesterday.toISOString().slice(0, 10);
            break;
        case "week":
            // Get the most recent Sunday, then go back 7 days for previous week
            const prevSunday = new Date(today);
            prevSunday.setDate(today.getDate() - today.getDay() - 7);
            const prevSaturday = new Date(prevSunday);
            prevSaturday.setDate(prevSunday.getDate() + 6);
            startDate = prevSunday.toISOString().slice(0, 10);
            endDate = prevSaturday.toISOString().slice(0, 10);
            break;
        case "month":
            const prevMonthStart = new Date(today.getFullYear(), today.getMonth() - 1, 1);
            const prevMonthEnd = new Date(today.getFullYear(), today.getMonth(), 0);
            startDate = prevMonthStart.toISOString().slice(0, 10);
            endDate = prevMonthEnd.toISOString().slice(0, 10);
            break;
        case "year":
            const prevYearStart = new Date(today.getFullYear() - 1, 0, 1);
            const prevYearEnd = new Date(today.getFullYear() - 1, 11, 31);
            startDate = prevYearStart.toISOString().slice(0, 10);
            endDate = prevYearEnd.toISOString().slice(0, 10);
            break;
        default:
            startDate = endDate = today.toISOString().slice(0, 10);
    }

    return { startDate, endDate };
};

export const exportExcelFile = (columns, data, fileName) => {
    const workbook = new ExcelJS.Workbook()
    const workSheet = workbook.addWorksheet('Report-Data')

    // Set up the columns
    workSheet.columns = columns

    // Apply styles to the header row
    const headerRow = workSheet.getRow(1)
    headerRow.eachCell((cell) => {
        cell.font = { bold: true }
        cell.fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: 'FFC0C0C0' }, // Light gray color for the header background
        }
        cell.alignment = { horizontal: 'center' }
    })

    // Add data to the worksheet
    data.forEach((element) => {
        workSheet.addRow(element)
    })

    // Center align all cells and adjust row height
    workSheet.eachRow({ includeEmpty: true }, (row) => {
        row.eachCell({ includeEmpty: true }, (cell) => {
            cell.alignment = { horizontal: 'center' }
        })
    })

    // Write the workbook to a buffer and create a Blob for download
    workbook.xlsx.writeBuffer().then((buffer) => {
        const blob = new Blob([buffer], {
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        })
        const url = window.URL.createObjectURL(blob)
        const anchor = document.createElement('a')
        anchor.href = url
        anchor.download = fileName
        anchor.click()
        window.URL.revokeObjectURL(url)
    })
}

export const getCardName = (code) => {
    const cardMap = {
        VC: "Visa Credit",
        VD: "Visa Debit",
        VE: "Visa Electron",
        VP: "Visa Corporate Purchasing Card",
        VB: "Visa Corporate",

        MC: "Mastercard Credit",
        MD: "Mastercard Debit",
        MA: "Mastercard Maestro",
        MM: "Mada",

        AM: "American Express",
        AP: "American Express Corporate Purchasing Card",

        DN: "Diners Club",
        JC: "JCB",
        DS: "Discover",

        A1: "Apple Pay Visa",
        A2: "Apple Pay Mastercard",
        A3: "Apple Pay Amex",
        A4: "Apple Pay Discover",
        A5: "Apple Pay JCB",
        A6: "Apple Pay Mada",

        S1: "Samsung Pay Visa",
        S2: "Samsung Pay Mastercard",
        S3: "Samsung Pay Amex",
        S4: "Samsung Pay Discover",
        S5: "Samsung Pay JCB",
        S6: "Samsung Pay Mada",

        PP: "PayPal",
        SP: "STC Pay",
        TB: "Tabby",
        UP: "Union Pay",
        UR: "UR Pay",
        JP: "Jeel Pay",
        ED: "Sadad Bill"
    };

    return cardMap[code] || code;
}

